import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalAdmin = ({
  show,
  handleClose,
  handleSave,
  title,
  children,
  saveButtonText,
  isSaveDisabled,
  formId
}) => {
  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button type="submit" variant="primary" form={formId} disabled={isSaveDisabled}>
          {saveButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAdmin;
